import { decamelizeKeys } from 'humps'
import { stadiumApi, porticoApi } from 'utils/axios'

export const fetchAllOrders = (params) => {
  const {
    venueUuid = null,
    fromDate = null,
    toDate = null,
    per = null,
    page = null,
    state = null,
    standUuid = null,
    orderNumber = null,
    userName = null,
    uuid = null,
    lastFour = null,
  } = params

  return stadiumApi.get('operator/orders', {
    params: {
      venue_uuid: venueUuid,
      from_date: fromDate,
      to_date: toDate,
      per,
      page,
      state,
      stand_uuid: standUuid,
      order_number: orderNumber,
      user_name: userName,
      uuid,
      last_4: lastFour,
    },
  })
}

export const fetchOrder = (id) => stadiumApi.get(`operator/orders/${id}`)

export const fetchRefundOrders = (venueUuid, confirmationNumber, config) =>
  stadiumApi.get('mobile_web/v1/refund/orders', {
    params: {
      venue_uuid: venueUuid,
      confirmation_number: confirmationNumber,
    },
    ...config,
  })

export const refundOrderItems = (
  orderId,
  lineItemUuids,
  reason,
  refundedByEmail,
  refundedByUuid
) => {
  return stadiumApi.put(`mobile_web/v1/refund/order/${orderId}`, {
    lineItemUuids,
    reason,
    refundedByEmail,
    refundedByUuid,
  })
}

export const fetchVenues = () => porticoApi.get('/devices/venues')

export const applyRefundToOrder = (orderId) =>
  stadiumApi.put(`/refund/apply/${orderId}`)

export const sendReceipt = (orderUuid, emails, paymentUuid) => {
  let params = decamelizeKeys({ orderUuid, emails, paymentUuid })
  return stadiumApi.post(
    `/pos/orders/${orderUuid}/emails/PosOrderReceiptEmailJob`,
    {
      ...params,
    }
  )
}

export const updateStatus = (uuid, data) => {
  const params = decamelizeKeys(data)
  return stadiumApi.patch(`pos/orders/${uuid}`, {
    ...params,
  })
}

export const fetchRevenueCenters = (venueUuid) =>
  stadiumApi.get('external/stands', {
    params: {
      venue_uuid: venueUuid,
    },
  })

export default {
  fetchAllOrders,
  fetchRefundOrders,
  refundOrderItems,
  applyRefundToOrder,
  fetchVenues,
  fetchOrder,
  updateStatus,
  fetchRevenueCenters,
}
